// Request headers.

const headers = {
  'Content-Type': 'application/vnd.api+json',
  Accept: 'application/vnd.api+json',
  'X-Consumer-ID': '8cae1660-fe5c-4eb0-81a8-181acc412209',
};

export default headers;
